import { SVGIconData } from '../components/core/interfaces/Icon';
import { h } from '@stencil/core';

/**
 * Enum to define default width and height for SVG
 */
enum SVGDefaults {
  WIDTH = 384,
  HEIGHT = 512,
}

/**
 * Generates an SVG image
 * @param   {IconData}       icon        The SVG image properties
 * @param   {string}            className   The SVG image class name
 * @returns {HTMLElement}                   The generated SVG image
 */
export const generateSVGImage = (icon: SVGIconData, className?: string): HTMLElement => {
  const svgWidth = icon.width ?? SVGDefaults.WIDTH;
  const svgHeight = icon.height ?? SVGDefaults.HEIGHT;

  return (
    <svg class={className ? className : null} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${svgWidth} ${svgHeight}`}>
      <path d={icon.data} />
    </svg>
  ) as HTMLElement;
};
